<span *ngIf="infoIconEnabled" class="information-icon">
  <ion-icon
    data-cy="information-icon"
    name="information-circle-outline"
  ></ion-icon>
</span>
